import { useState, useRef, useCallback, useEffect } from 'react';

const useCountdown = (initialTime = 1800) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isActive, setIsActive] = useState(false);
  const intervalRef = useRef(null);

  // Function to clear the existing interval
  const clearCountdownInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Function to start the countdown
  const startCountdown = useCallback((onComplete = () => {}) => {
    // Reset timer if needed
    setTimeLeft(initialTime);
    setIsActive(true);
    
    // Clear any existing interval first
    clearCountdownInterval();
    
    // Start a new interval
    intervalRef.current = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearCountdownInterval();
          setIsActive(false);
          // Execute the callback when countdown completes
          onComplete();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  }, [initialTime]);

  // Function to pause the countdown
  const pauseCountdown = useCallback(() => {
    clearCountdownInterval();
    setIsActive(false);
  }, []);

  // Function to reset the countdown
  const resetCountdown = useCallback(() => {
    clearCountdownInterval();
    setTimeLeft(initialTime);
    setIsActive(false);
  }, [initialTime]);

  // Clean up on unmount
  useEffect(() => {
    return () => clearCountdownInterval();
  }, []);

  return { 
    timeLeft, 
    isActive, 
    startCountdown, 
    pauseCountdown, 
    resetCountdown 
  };
};

export default useCountdown;